import { useInfiniteQuery } from '@tanstack/react-query';
import { trpc, type RouterOutputs } from '../../api/trpc';

export type EventRow = RouterOutputs['auditLog']['events']['items'][number];

export function useEvents(action: string, enabled = true, limit = 100) {
  return useInfiniteQuery(
    trpc.auditLog.events.infiniteQueryOptions(
      { action: action || undefined, limit },
      { getNextPageParam: (last) => last.nextCursor, enabled },
    ),
  );
}
